<div class="max-width-500">
  <form
    [formGroup]="changePasswordRequestForm"
    (ngSubmit)="changePasswordRequest()"
  >
    <ion-grid fixed="true">
      <ion-row>
        <ion-col size="12">
          <div class="login-box block-content-round">
            <lib-login-logo></lib-login-logo>
            <ion-grid>
              <ion-row>
                <ion-col>
                  <h2 class="ion-margin-top-0 ion-text-center">
                    {{ 'account.change_password_request' | translate }}
                  </h2>
                  <p>
                    {{ 'account.enter_email_to_reset_password' | translate }}
                  </p>

                  <ion-input
                    formControlName="email"
                    type="text"
                    label="{{ 'users.email' | translate }}"
                    labelPlacement="floating"
                    placeholder="{{ 'users.email' | translate }}"
                    fill="outline"
                    mode="md"
                    [clearOnEdit]="false"
                    [helperText]="changePasswordRequestHelperText"
                    [errorText]="changePasswordRequestErrorText"
                  ></ion-input>
                </ion-col>
              </ion-row>
              @if (errorMessage()) {
                <ion-row>
                  <ion-col>
                    <div class="errors">
                      {{ errorMessage() }}
                    </div>
                  </ion-col>
                </ion-row>
              }

              @if (isDesktopView()) {
                <ion-row>
                  <ion-col>
                    <div class="max-width-500">
                      <ion-button
                        expand="block"
                        type="submit"
                        fill="solid"
                        [disabled]="isOffline()"
                      >
                        {{ 'general.send' | translate }}
                      </ion-button>
                    </div>
                  </ion-col>
                </ion-row>
              }
              <ion-row>
                <ion-col>
                  <p>
                    {{ 'account.change_password_confirm_navigate' | translate }}
                    <a [routerLink]="['/recover-password-confirm']">
                      {{ 'general.press_here' | translate }}
                    </a>
                  </p>
                  <p class="ion-text-center fs-sm ion-margin-top">
                    <a [routerLink]="['/login']">
                      {{ 'login.back_to_login' | translate }}
                    </a>
                  </p>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</div>
